document.addEventListener(`DOMContentLoaded`, (e) => {
    const reviewCarouselEl = document.querySelector(`.lsg-review-block__carousel`),
          settings = {};

    settings.prevNextButtons = true;
    settings.wrapAround = true;
    settings.adaptiveHeight = true;

    const carouselEl = new window.Flickity(reviewCarouselEl, settings);
});